import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import buscador from '@/components/buscador'
import grafica from '@/components/grafica'
import graficaLineal from '@/components/graficaLineal'
import chartHistory from '@/components/chartHistory'
import login from '@/components/login.vue'

Vue.use(Router)
Vue.component('index', index)
Vue.component('buscador', buscador)
Vue.component('grafica', grafica)
Vue.component('graficaLineal', graficaLineal)
Vue.component('chartHistory', chartHistory)
Vue.component('login', login)

const router = new Router({
  el: '#app',
  mode: 'history',
  data: {
    arrayCripto: []
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/grafica/:id',
      name: 'grafica',
      component: grafica
    },
    {
      path: '/graficaLineal',
      name: 'graficaLineal',
      component: graficaLineal
    },
    {
      path: '/chartHistory',
      name: 'chartHistory',
      component: chartHistory
    },
    {
      path: '/login',
      name: 'login',
      component: login
    }
  ]
})
function isTokenExpired (token) {
  if (!token) {
    return true
  }
  const tokenData = JSON.parse(atob(token.split('.')[1]))
  const tokenExpiration = tokenData.exp * 1000
  const currentTime = Date.now()
  return tokenExpiration < currentTime
}

router.beforeEach((to, from, next) => {
  const isAuthenticated = !isTokenExpired(localStorage.getItem('token'))
  if (!isAuthenticated && to.name !== 'login') {
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js